import { render, staticRenderFns } from "./salesGoodsDetail.vue?vue&type=template&id=33547db4&scoped=true"
import script from "./salesGoodsDetail.vue?vue&type=script&lang=js"
export * from "./salesGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./salesGoodsDetail.vue?vue&type=style&index=0&id=33547db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33547db4",
  null
  
)

export default component.exports